import { render, staticRenderFns } from "./passengerItemInt.vue?vue&type=template&id=3a5bba31&"
import script from "./passengerItemInt.vue?vue&type=script&lang=js&"
export * from "./passengerItemInt.vue?vue&type=script&lang=js&"
import style0 from "./passengerItemInt.vue?vue&type=style&index=0&id=3a5bba31&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports